import { api } from './config';

export interface LoginRequest {
  mobile: string;
}

export interface VerifyOtpRequest {
  mobile: string;
  otp: string;
}

export interface SendOtpResponse {
  message: string;
  data: {
    already_exists: boolean;
  };
}

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    mobile: string;
  };
}

export interface VerifyOtpResponse {
  session_id: string;
  max_age: number;
  user: any;
}

export const requestOtp = async (data: LoginRequest): Promise<SendOtpResponse> => {
  try {
    const response = await api.post('/api/v1/user/auth/send_otp/', {
      mobile: data.mobile.toString(),
      domain: window.location.hostname,
      x_domain: window.location.hostname,
      'x-app-name': 'retailer'
    });
    return response.data;
  } catch (error: any) {
    console.error('Send OTP Error:', error);
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to send OTP. Please try again.');
  }
};

export const verifyOtp = async (data: VerifyOtpRequest): Promise<VerifyOtpResponse> => {
  try {
    const response = await api.post('/api/v1/user/auth/verify_otp/', {
      mobile: data.mobile.toString(),
      otp: data.otp,
      domain: window.location.hostname,
      x_domain: window.location.hostname,
      'x-app-name': 'retailer'
    });

    // Store the session_id if present
    if (response.data.session_id) {
      localStorage.setItem('session_id', response.data.session_id);
    }
    // Store the mobile number as well
    if (data.mobile) {
      localStorage.setItem('mobile', data.mobile.toString());
    }

    return response.data;
  } catch (error: any) {
    console.error('Verify OTP Error:', error);
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to verify OTP. Please try again.');
  }
};

// Restore session and user from localStorage if available
export const restoreAuthFromStorage = () => {
  const session_id = localStorage.getItem('session_id');
  const userStr = localStorage.getItem('user');
  let user = null;
  if (userStr) {
    try {
      user = JSON.parse(userStr);
    } catch {}
  }
  return { session_id, user };
};
